import _extends from "@babel/runtime-corejs3/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useContext, useState, useEffect, useRef, useCallback, useImperativeHandle } from 'react';
import Input from '../input';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
import { serialization } from '../_utils/numberUtil';
import { formatEditNumber, formatNumber } from '../_utils/formatUtil';
import devWarning from '../_utils/devwarning';
import Big from 'big.js';
import classNames from 'classnames';

var InternalInputNumber = function InternalInputNumber(props, ref) {
  var _useContext = useContext(ConfigContext),
      userDefaultProps = _useContext.compDefaultProps,
      getPrefixCls = _useContext.getPrefixCls,
      prefixCls = _useContext.prefixCls;

  var inputNumberProps = getCompProps('InputNumber', userDefaultProps, props);

  var value = inputNumberProps.value,
      defaultValue = inputNumberProps.defaultValue,
      mustInScope = inputNumberProps.mustInScope,
      decimalLength = inputNumberProps.decimalLength,
      mustInPrecisionScope = inputNumberProps.mustInPrecisionScope,
      digitLength = inputNumberProps.digitLength,
      onChange = inputNumberProps.onChange,
      symbol = inputNumberProps.symbol,
      zeroShow = inputNumberProps.zeroShow,
      showDecimalTailZero = inputNumberProps.showDecimalTailZero,
      code = inputNumberProps.code,
      roundMethod = inputNumberProps.roundMethod,
      mask = inputNumberProps.mask,
      stepOption = inputNumberProps.stepOption,
      min = inputNumberProps.min,
      minMark = inputNumberProps.minMark,
      max = inputNumberProps.max,
      maxMark = inputNumberProps.maxMark,
      prefix = inputNumberProps.prefix,
      suffix = inputNumberProps.suffix,
      formatter = inputNumberProps.formatter,
      className = inputNumberProps.className,
      others = __rest(inputNumberProps, ["value", "defaultValue", "mustInScope", "decimalLength", "mustInPrecisionScope", "digitLength", "onChange", "symbol", "zeroShow", "showDecimalTailZero", "code", "roundMethod", "mask", "stepOption", "min", "minMark", "max", "maxMark", "prefix", "suffix", "formatter", "className"]);

  var initVal = value === undefined ? defaultValue : value;

  var _useState = useState(serialization(initVal || '')),
      _useState2 = _slicedToArray(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var inputStatus = useRef({
    isHandleChange: false,
    inputFocused: false
  });
  var inputPrefixCls = getPrefixCls(prefixCls, 'inputNumber', inputNumberProps.prefixCls);
  var thisInputNumberRef = useRef();
  var inputNumberRef = ref || thisInputNumberRef;
  var stepMouseDownDelayTimer = useRef(null);
  var stepMouseDownIntervalTimer = useRef(null);

  var isScopeValid = function isScopeValid(value) {
    if (value === '') return true;
    var numberValue = parseFloat(value) || 0;
    if (min >= 0 && value.substr(0, 1) === '-') return false; // 数值范围>=0时,不允许输入负号

    if (minMark === '[' && numberValue < min || minMark === '(' && numberValue <= min || maxMark === ']' && numberValue > max || maxMark === ')' && numberValue >= max) return false;
    return true;
  };

  useEffect(function () {
    setInputValue(value);
  }, [value]);

  var handleEventAttachValue = function handleEventAttachValue(event, value) {
    return _extends({}, event, {
      target: {
        value: value
      }
    });
  };

  var verifiValue = function verifiValue(initValue) {
    // 将 value 进行数字序列化 剔除非数字输入-复制粘贴的情况
    var value = serialization(initValue); // 校验数字合法性

    if (!/^-?\d*\.?\d*$/.test(value)) return false; // 输入内容超出数字范围不允许输入

    if (mustInScope && !isScopeValid(value)) {
      return false;
    } // 整数字段不允许输入小数点


    if (decimalLength === 0 && _includesInstanceProperty(value).call(value, '.')) {
      return false;
    }

    if (mustInPrecisionScope) {
      value = handleNumericalAccuracy(value);
      if (value === inputValue) return false;
    }

    return value;
  };

  var handleChange = function handleChange(event) {
    inputStatus.current.isHandleChange = true;
    var legalNumber = verifiValue(event.target.value);

    if (legalNumber === false) {
      return false;
    }

    value === undefined && setInputValue(legalNumber);
    onChange && onChange(handleEventAttachValue(event, legalNumber));
  };

  var handleFocus = function handleFocus(event) {
    inputStatus.current.inputFocused = true;
    var onFocus = inputNumberProps.onFocus;
    var formatValue = formatEditNumber(inputValue, {
      zeroShow: zeroShow,
      decimalLength: decimalLength,
      showDecimalTailZero: showDecimalTailZero,
      roundMethod: roundMethod,
      symbol: symbol
    });
    value === undefined && setInputValue(formatValue);
    onFocus && onFocus(handleEventAttachValue(event, formatValue));
  };

  var handleFormatValue = function handleFormatValue(value, param) {
    if (!value && value !== 0) return '';
    return formatNumber(value, param);
  };

  var handleNumericalAccuracy = function handleNumericalAccuracy(numerical) {
    var resultNumerical = '';

    var _numerical$split = numerical.split('.'),
        _numerical$split2 = _slicedToArray(_numerical$split, 2),
        integerValue = _numerical$split2[0],
        _numerical$split2$ = _numerical$split2[1],
        decimalValue = _numerical$split2$ === void 0 ? '' : _numerical$split2$;

    var integerValueLength = integerValue.length;
    var decimalValueLength = decimalValue.length;

    if (typeof decimalLength === 'number' && typeof digitLength === 'number') {
      if (integerValueLength > digitLength - decimalLength) {
        resultNumerical = integerValue.substr(0, digitLength - decimalLength);
      } else if (decimalValueLength > decimalLength) {
        var _context;

        resultNumerical = _concatInstanceProperty(_context = "".concat(integerValue, ".")).call(_context, decimalValue.substr(0, decimalLength));
      }
    } else if (typeof decimalLength !== 'number' && typeof digitLength === 'number') {
      if (integerValueLength >= digitLength) {
        resultNumerical = integerValue.substr(0, digitLength);
      } else {
        var _context2;

        resultNumerical = decimalValueLength ? _concatInstanceProperty(_context2 = "".concat(integerValue, ".")).call(_context2, decimalValue.substr(0, digitLength - integerValueLength)) : integerValue;
      }
    } else if (typeof decimalLength === 'number' && typeof digitLength !== 'number') {
      var _context3;

      resultNumerical = decimalValueLength ? _concatInstanceProperty(_context3 = "".concat(integerValue, ".")).call(_context3, decimalValue.substr(0, decimalLength)) : integerValue;
    } else {
      resultNumerical = numerical;
    }

    if (inputStatus.current.inputFocused && resultNumerical.indexOf('.') === -1 && numerical.indexOf('.') > -1 && numerical.indexOf('.') === numerical.length - 1) {
      resultNumerical += '.';
    }

    return resultNumerical;
  };

  var handleStepChang = function handleStepChang(type) {
    var step = stepOption.step === undefined ? 1 : parseFloat(stepOption.step);

    if (typeof step !== 'number') {
      devWarning(true, 'inputNumber', "stepOption.step\u5FC5\u987B\u4E3A\u4E00\u4E2A\u6570\u503C");
      return false;
    }

    var startingNumber = parseFloat(inputNumberRef.current.value) || 0;
    var calculationResults = new Big(startingNumber)[type](step).valueOf();
    var legalNumber = verifiValue(calculationResults);

    if (legalNumber === false) {
      return false;
    }

    setInputValue(legalNumber);
    onChange && onChange({
      target: {
        value: legalNumber
      }
    });
  };

  var handleKeyDown = function handleKeyDown(event) {
    var _context4;

    if (!stepOption || props.disabled || props.readOnly) {
      return;
    }

    var keyCode = event.keyCode;

    if (_includesInstanceProperty(_context4 = [38, 40]).call(_context4, keyCode)) {
      event.preventDefault();
      handleStepChang(keyCode === 38 ? 'plus' : 'minus');
    }
  };

  var clearAllTimer = useCallback(function () {
    stepMouseDownDelayTimer.current && clearTimeout(stepMouseDownDelayTimer.current);
    stepMouseDownIntervalTimer.current && clearInterval(stepMouseDownIntervalTimer.current);
    document.removeEventListener('mouseup', clearAllTimer);
    return false;
  }, [stepMouseDownDelayTimer, stepMouseDownIntervalTimer]);

  var handleBlur = function handleBlur(event) {
    inputStatus.current.isHandleChange = false;
    inputStatus.current.inputFocused = false;
    var min = inputNumberProps.min,
        max = inputNumberProps.max,
        onBlur = inputNumberProps.onBlur;
    var _inputValue = inputValue;

    if (_inputValue === '-') {
      _inputValue = '';
    }

    var bigValue = new Big(Number(_inputValue)); // 还原最小值

    if (typeof min === 'number' && bigValue.lt(min)) {
      _inputValue = min.toString();
    } // 还原最大值


    if (typeof min === 'number' && bigValue.gt(max)) {
      _inputValue = max.toString();
    } // 超过精度位数直接截断


    _inputValue = handleNumericalAccuracy(_inputValue);
    var formatValue = handleFormatValue(_inputValue, {
      mask: mask,
      zeroShow: zeroShow,
      decimalLength: decimalLength,
      showDecimalTailZero: showDecimalTailZero,
      symbol: symbol,
      code: code
    });
    setInputValue(formatValue);
    onBlur && onBlur(handleEventAttachValue(event, _inputValue));
    inputStatus.current.isHandleChange = false;
    inputStatus.current.inputFocused = false;
  };

  useEffect(function () {
    var _inputStatus$current = inputStatus.current,
        isHandleChange = _inputStatus$current.isHandleChange,
        inputFocused = _inputStatus$current.inputFocused;

    if (isHandleChange) {
      return;
    }

    setInputValue(function (_inputValue) {
      var isValueChange = value !== (inputFocused ? _inputValue : formatEditNumber(_inputValue, {
        zeroShow: zeroShow,
        decimalLength: decimalLength,
        showDecimalTailZero: showDecimalTailZero,
        roundMethod: roundMethod,
        symbol: symbol
      }));

      if (!inputFocused || isValueChange) {
        if (value === '' || value === null) {
          return '';
        } else {
          var formatValue = inputFocused ? formatEditNumber(value, {
            zeroShow: zeroShow,
            decimalLength: decimalLength,
            showDecimalTailZero: showDecimalTailZero
          }) : handleFormatValue(value, {
            mask: mask,
            zeroShow: zeroShow,
            decimalLength: decimalLength,
            showDecimalTailZero: showDecimalTailZero,
            symbol: symbol,
            code: code
          });
          return formatValue;
        }
      }

      return _inputValue;
    });
  }, [value, zeroShow, decimalLength, showDecimalTailZero, symbol, code, roundMethod, mask]);
  useEffect(function () {
    return function () {
      clearAllTimer();
    };
  }, [clearAllTimer]);
  useImperativeHandle(props.stepperrref, function () {
    return {
      value: inputValue,
      handleNumericalAccuracy: handleNumericalAccuracy,
      verifiValue: verifiValue,
      setValue: function setValue(value) {
        return setInputValue(value);
      }
    };
  });
  return /*#__PURE__*/React.createElement(Input, _extends({}, others, {
    ref: inputNumberRef,
    value: inputValue ? (formatter === null || formatter === void 0 ? void 0 : formatter(inputValue)) || inputValue : inputValue,
    prefix: prefix,
    suffix: suffix,
    onChange: handleChange,
    onFocus: handleFocus,
    onBlur: handleBlur,
    onKeyDown: handleKeyDown,
    className: classNames(inputPrefixCls, className)
  }));
};

var InputNumber = /*#__PURE__*/React.forwardRef(InternalInputNumber);
InputNumber.displayName = 'InputNumber';
export default InputNumber;